import * as React from 'react';
import styled from 'styled-components';
import { Tabs } from 'antd';
import { Color } from '@bb/elements-web';

const { TabPane } = Tabs;

interface VirtualTourListTabProps {
  setActionTab?: (key: any) => void;
  hasVSFeatureFlag: boolean;
}
type showingTypes = 'inPersonShowing' | 'virtualShowing';

const VirtualTourListTab: React.FC<VirtualTourListTabProps> = ({
  setActionTab,
  hasVSFeatureFlag,
}) => {
  const changeHandler = (key: showingTypes) => {
    setActionTab(key);
  };

  return (
    <div>
      <StyledTabs
        tabBarStyle={{
          width: '98%',
          margin: 'auto',
          paddingLeft: '5px',
        }}
        onChange={(key: showingTypes) => changeHandler(key)}
      >
        <TabPane tab=" In Person" key="inPersonShowing" />
        {hasVSFeatureFlag && (
          <TabPane tab="Virtual Showing" key="virtualShowing" />
        )}
      </StyledTabs>
      <br />
    </div>
  );
};

export default VirtualTourListTab;

const StyledTabs = styled(Tabs)`
  .ant-tabs-ink-bar {
    background-color: ${Color.PRIMARY};
  }
`;
